import { useEffect, useRef, useState } from 'react';

const TRANSITION_DURATION = 300;

export const useFilterVideos = (elements: any[], show: boolean) => {
  const [filteredVideos, setFilteredVideos] = useState(elements);
  const timerRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    clearTimeout(timerRef.current);

    timerRef.current = setTimeout(
      () =>
        setFilteredVideos(
          elements.filter(({ type }) => show || type !== 'video')
        ),
      show ? 0 : TRANSITION_DURATION
    );

    return () => {
      clearTimeout(timerRef.current);
    };
  }, [elements, show]);

  return filteredVideos;
};
